import { Navigate, useLocation } from "react-router";
import { useSelector } from "react-redux";

/** Auth-only screens — unnecessary once the user already has a session. */
const AUTH_ONLY_PATHS_REDIRECT_WHEN_SIGNED_IN = new Set([
  "/signin",
  "/signup",
  "/forgot-password",
  "/reset-password",
]);

/**
 * Wraps sign-in, sign-up, forgot/reset password.
 * - Marketing routes stay open to everyone.
 * - Any **signed-in** user hitting these paths is sent home (no duplicate login / verify loop).
 */
const PublicRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useSelector((state) => state.infoboxx_consumer);
  const path = location.pathname;

  if (isAuthenticated && AUTH_ONLY_PATHS_REDIRECT_WHEN_SIGNED_IN.has(path)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
